// extracted by mini-css-extract-plugin
export var answer = "index-module--answer--oRSxg";
export var content = "index-module--content--CaaC1";
export var question = "index-module--question--O54mf";
export var questionContainer = "index-module--questionContainer--qoaEF";
export var questionPage = "index-module--questionPage--B8m0I";
export var smallContent = "index-module--smallContent--SVOQI";